import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiEndpoints } from '@app/utils/enums/api-endpoints';
import { UserDataResponse, UserData } from '@app/utils/interfaces/user-data';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GetUserService {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly http = inject(HttpClient);

  getUser(id: string): Observable<UserDataResponse> {
    return this.http.get<UserDataResponse>(`${this.baseUrl}${ApiEndpoints.GET_USER}/${id}`);
  }

  putUser(id: string, data: UserData): Observable<UserData> {
    return this.http.put<UserData>(
      `${this.baseUrl}${ApiEndpoints.GET_USER}/${id}/personal-info`,
      data,
    );
  }
}
